// import Umami from "sherlock.js"

export default class Sherlock {

    static myInstance = null;

    _session_params = null;

    /**
     * @returns {CommonDataManager}
     */
    static getInstance() {
        if (Sherlock.myInstance == null) {
            Sherlock.myInstance = new Sherlock();

            let script = document.createElement("script");
            script.src = "./sherlock.js?v=2";
            script.setAttribute("data-website-id", "08540105-767b-4b0c-8695-ede5ca9f2874");
            document.head.append(script);

        }

        return this.myInstance;
    }

    _handleVisibilityChange() {
      console.log("Visibility change");
      if (document.visibilityState === "hidden") {
        this.appOnBackground();
      } else {
        this.appOnScreen();
      }
    }

    setGlobalParams(params){
      this._session_params = params;
    }

    appLoaded(){
      sherlock.track('app_loaded', this._session_params);
    }

    appOnScreen(){
      sherlock.track('app_on_screen')
    }

    appOnBackground(){
      sherlock.track('app_on_background')
    }



    buttonClicked(action, data = null){
      sherlock.track('button_clicked', {
        action: action,
        data: data
      });
    }


}
